/**
 * /canal (ES) and /channel (EN): membership funnel surface.
 *
 * AR → redirect a `/` (BaseTemplate, sin Mux). El player legacy
 * (MuxVideoPlayerWithCTA service=channel_invite) dependía de
 * VITE_TELEGRAM_GROUPS_* que no existen en Railway → pantalla
 * "Video no disponible" + alerta Slack config_missing para TODOS los países.
 *
 * No-AR → DualCTAVideoLanding: configurable por país desde
 * /admin/dual-cta-variants (scope country: video Mux, precio, stripe_price_id/
 * stripe_product_id, labels) y /admin/country-template. El checkout Stripe
 * (api/create-subscription-checkout) etiqueta metadata.source=juaperrone en
 * sesión y subscription.
 *
 * Excepciones al redirect AR (QA desde Argentina): super admin, preview
 * embebido admin y ?_force_variant. El geo-sim (?gst=/?country=) no necesita
 * excepción: isArgentinaVisitor() lee el país que el worker resolvió, que ya
 * refleja la simulación.
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DualCTAVideoLanding from "./DualCTAVideoLanding";
import { isArgentinaVisitor } from "@/lib/arIntlSeoFunnelRedirect";
import { useIsSuperAdmin } from "@/lib/auth";
import { useAdminEmbeddedPreviewDocument } from "@/hooks/useAdminEmbeddedPreviewDocument";

export default function ChannelInviteLanding() {
  const isSuperAdmin = useIsSuperAdmin();
  const embeddedPreview = useAdminEmbeddedPreviewDocument();
  const navigate = useNavigate();

  const isPreviewVariant =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).has("_force_variant");

  const shouldForceBaseTemplate =
    isArgentinaVisitor() && !isSuperAdmin && !embeddedPreview && !isPreviewVariant;

  useEffect(() => {
    if (!shouldForceBaseTemplate) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const posthog = (window as any).posthog;
    if (posthog) {
      posthog.capture("ar_redirect_to_base_template", {
        reason: "canal_channel_invite",
        target: "BaseTemplate",
        pathname: window.location.pathname,
        search: window.location.search,
        timestamp: new Date().toISOString(),
      });
    }
    navigate("/", { replace: true });
  }, [shouldForceBaseTemplate, navigate]);

  if (shouldForceBaseTemplate) {
    return <div className="w-full h-dvh bg-black" />;
  }

  return <DualCTAVideoLanding />;
}
